import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import CloseIcon from 'assets/icons/close.svg?react';
import useCalculator from 'hooks/calculator/useCalculator';
import { useConstraints } from 'hooks/context';
import DrawerOffer from './DrawerOffer';
import { TwButton } from '../TwButton/TwButton';
import Sliders from '../Sliders/Sliders';

interface DrawerProps {
  drawerOpen: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
}

export default function Drawer({
  drawerOpen,
  handleConfirm,
  handleCancel,
}: DrawerProps) {
  const { t } = useTranslation([
    'calculator',
    'common',
    'identification_expired',
  ]);
  const { amount, handleAmountChange, offer } = useCalculator();
  const { constraints } = useConstraints();

  return (
    <div
      data-test="drawer"
      className={twMerge(
        'absolute bg-background px-8 pt-5 pb-20 flex flex-col w-full z-10 transition-transform',
        'left-0 right-0 border-b -translate-y-full',
        'lg:right-auto lg:border-b-0 lg:border-r lg:w-80 lg:h-full lg:min-h-full lg:top-0 lg:-translate-x-full lg:pt-11 lg:-translate-y-0',
        drawerOpen && 'translate-y-0',
        drawerOpen && 'lg:translate-x-0',
      )}
    >
      <button
        type="button"
        onClick={handleCancel}
        className="hidden lg:absolute lg:w-10 lg:h-10 lg:flex lg:justify-center lg:items-center lg:top-2 lg:right-2"
      >
        <span className="sr-only">{t('identification_expired:close')}</span>
        <CloseIcon />
      </button>
      <div className="hidden lg:block  border-b pb-4 ">
        <div className="leading-5 font-medium text-lg pb-4">{t('edit')}</div>
      </div>
      <div className="lg:my-5 flex flex-col gap-8 pt-12">
        <Sliders
          constraints={constraints}
          onAmountChange={handleAmountChange}
          amount={amount}
        />

        <DrawerOffer
          amount={offer?.newPrincipal}
          mtp={offer?.loanExtensionFees[0]?.fee}
          dueDate={offer?.firstPaymentDate}
        />

        <div
          className="text-xs text-muted"
          data-test="drawer-calculator-example"
          dangerouslySetInnerHTML={{
            __html: import.meta.env.VITE_CALCULATOR_HTML_TEXT,
          }}
        />

        <TwButton
          className="my-5 mx-auto"
          disabled={!constraints}
          onClick={handleConfirm}
        >
          {t('common:confirm')}
        </TwButton>
      </div>
    </div>
  );
}
